import { render, staticRenderFns } from "./workInfos.vue?vue&type=template&id=268bb3bb&scoped=true&"
import script from "./workInfos.vue?vue&type=script&lang=ts&"
export * from "./workInfos.vue?vue&type=script&lang=ts&"
import style0 from "./workInfos.vue?vue&type=style&index=0&id=268bb3bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268bb3bb",
  null
  
)

export default component.exports